'use strict';

angular.module('cgmemApp')
  .controller('MailPrefsCtrl', function ($scope, $state, $stateParams, $window, $log, $q, $http, AppConfig) {

    $scope.ready = false;
    $scope.alert = "";

    var options = {
      params: {
        'jwt': $stateParams.jwt
      }
    }
    var url = '/api/mailprefs';

    $q.all([AppConfig.get(), $http.get(url, options)])
      .then(function (d) {
        $scope.mailingLists = angular.copy(d[0].mailingLists);  // copy to avoid polluting AppConfig
        _.forEach($scope.mailingLists, function (l) {
          l.value = (d[1].data.indexOf(l.code) >= 0); // for each list,set "value" to true/false depending on presence of code in list
        });
        $scope.ready = true;
      })
      .catch(function (err) {
        $scope.alert = "Your request failed - please try again later";
        $scope.ready = true;
      });

    $scope.update = function () {
      $scope.ready = false;
      var res = [];
      _.forEach($scope.mailingLists, function (l) {
        if (l.value)
          res.push(l.code);
      });
      $http.put(url, res, options)
        .then(function (d) {
          $scope.alert = "Your preferences have been updated.";
        })
        .catch(function (err) {
          $scope.alert = "Your request failed - please try again later";
        })
        .finally(function () {
          $scope.ready = true;
        })
    }
  });
